var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Input,{ref:"inputRef",attrs:{"state-key":_vm.stateKey,"custom-validator":_setup.customValidator}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }